import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type InboxAccountFragment = { __typename?: 'InboxAccount', id?: string | null, version?: number | null, imageUrl?: string | null, displayName?: string | null };

export const InboxAccount = /*#__PURE__*/ gql`
    fragment InboxAccount on InboxAccount {
  id
  version
  imageUrl
  displayName
}
    ` as unknown as DocumentNode<InboxAccountFragment, unknown>;

        

        
export const useInboxAccountFragment = (
  input: string | Omit<UseFragmentOptions<InboxAccountFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'InboxAccount' } };
    return input;
  })();

  return useFragment<InboxAccountFragment>({
    fragment: InboxAccount,
    fragmentName: 'InboxAccount',
    ...options,
  });
};
  
        